import React, { useEffect, useRef, useState } from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TextField, IconButton
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import axios from 'axios';
import { useReactToPrint } from 'react-to-print';

function Billhistory() {
  const ReturnprintsRef = useRef();
  const [billHeaders, setBillHeaders] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBillItems, setSelectedBillItems] = useState([]);
  const [selectedBillMeta, setSelectedBillMeta] = useState(null);

  useEffect(() => {
    axios.get('https://serverautoparts.mylksystems.com/billing/getBillHeaders')
      .then(res => {
        setBillHeaders(res.data);
        setFilteredBills(res.data);
      })
      .catch(err => console.error('Error fetching bill headers:', err));
  }, []);

  useEffect(() => {
    const filtered = billHeaders.filter(bill =>
      bill.inv_no.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredBills(filtered);
  }, [searchTerm, billHeaders]);

  const handlePrint = async (inv_no) => {
    try {
      const res = await axios.post(`https://serverautoparts.mylksystems.com/billing/getSingleBill`, { inv_no });
      if (res.data && res.data.length > 0) {
        const meta = {
          inv_no: res.data[0].billNo,
          username: res.data[0].username,
          inv_date: res.data[0].inv_date,
          gross_total: res.data[0].gross_total,
          discount: res.data[0].discount,
          net_total: res.data[0].net_total,
          Service_chrg: res.data[0].Service_chrg
        };
        setSelectedBillItems(res.data);
        setSelectedBillMeta(meta);
        setTimeout(() => handlePrintTrigger(), 200);
      }
    } catch (err) {
      console.error('Error fetching single bill:', err);
    }
  };

  const handlePrintTrigger = useReactToPrint({
    content: () => ReturnprintsRef.current,
  });

  const formatTwoDigits = (val) => (val < 10 ? `0${val}` : val);

  const renderPrintableBill = () => {
    if (!selectedBillMeta || selectedBillItems.length === 0) return null;
    
    const today = new Date();
    const year = today.getFullYear();
    const month = formatTwoDigits(today.getMonth() + 1);
    const day = formatTwoDigits(today.getDate());

    return (
      <div style={{ display: 'none' }}>
        <table
          border={0}
          width="300"
          style={{ fontFamily: 'Consolas', backgroundColor: 'white', fontWeight: 'bold' }}
          ref={ReturnprintsRef}
        >
          <tbody>
            <tr>
              <td colSpan={4} align="center">
                <img src={require('../Assests/billLogo.png')} alt="" width={150} style={{marginBottom:  -30}}/>
              </td>
            </tr>
             <tr>
              <td colSpan={4} align='center' style={{ fontSize: 14, fontWeight: 'bold' }}><label style={{ fontSize: 20 }}> </label><br></br> KESHAL INTERNATIONAL<br></br>
              WARAKAPOLA<br></br>
                <img src={require('../Assests/whatsapp.png')} alt='' width={10} style={{marginRight : 10}}></img>
              Tel. +81  70-4410-5446 (Jp.)  <br></br>
                <img src={require('../Assests/Call.png')} alt='' width={10} style={{marginRight : 10}}></img>
              Tel. +94 35 2269 940  <br></br>

               </td>
              
            </tr>
            <tr><td colSpan={4}>---------------------------------</td></tr>
            <tr><td colSpan={4}>Cashier: {selectedBillMeta.username}</td></tr>
            <tr><td colSpan={4}>Date: {selectedBillMeta.inv_date}</td></tr>
            <tr><td colSpan={4}>Invoice no: {selectedBillMeta.inv_no}</td></tr>
            <tr><td colSpan={4}>---------------------------------</td></tr>

            {selectedBillItems.map((e, i) => (
              <React.Fragment key={i}>
                <tr>
                  <td colSpan={4}>{i + 1}). {e.item_name}</td>
                </tr>
                <tr>
                  <td align="right">{e.qty}</td>
                  <td align="center">{parseFloat(e.unitprice).toFixed(2)}</td>
                  <td align="right">{parseFloat(e.total).toFixed(2)}</td>
                </tr>
              </React.Fragment>
            ))}

            <tr><td colSpan={4}>---------------------------------</td></tr>
            <tr>
              <td colSpan={2} align="left">Gross Rs.</td>
              <td colSpan={2} align="right"> {selectedBillMeta.gross_total}</td>
            </tr>
            <tr>
              <td colSpan={2} align="left">Discount Rs.</td>
              <td colSpan={2} align="right"> ({selectedBillMeta.discount})</td>
            </tr>
            <tr>
              <td colSpan={2} align="Left">Service Charge Rs.</td>
              <td colSpan={2} align="right"> {selectedBillMeta.Service_chrg}</td>
            </tr>
              <tr><td colSpan={4}>---------------------------------</td></tr>
            

            <tr><td colSpan={4} align="right"><b>Total Rs. {selectedBillMeta.net_total}</b></td></tr>
               <tr>
              <td colSpan={4} align='right'>==========</td>
            </tr>
            <tr><td colSpan={4} align="center" style={{fontSize : 12}}>Thank you, Come Again.</td></tr>
            <tr><td colSpan={4}>---------------------------------</td></tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <Box p={2} style={{ paddingTop: '100px' }}>
      <div style={{ textAlign: 'left', marginBottom: '20px', fontSize: '30px', fontWeight: 'bold' }}>
        Bill History
      </div>
      <TextField
        label="Search Invoice No"
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 2 }}
      />

      <TableContainer component={Paper} sx={{ maxHeight: 600, overflowY: 'auto' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>Invoice No</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Inv Date</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Gross</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Discount</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Net</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Service Chrg</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Cashier</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBills.map((bill, idx) => (
              <TableRow key={idx}>
                <TableCell>{bill.inv_no}</TableCell>
                <TableCell>{bill.inv_date}</TableCell>
                <TableCell>{bill.gross_total}</TableCell>
                <TableCell>{bill.discount}</TableCell>
                <TableCell>{bill.net_total}</TableCell>
                <TableCell>{bill.Service_chrg}</TableCell>
                <TableCell>{bill.username}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handlePrint(bill.inv_no)}>
                    <PrintIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {renderPrintableBill()}
    </Box>
  );
}

export default Billhistory;
